export const nav = {
  dashboard: "Dashboard",
  customers: "Customers",
  quotes: "Quotes & orders",
  catalog: "Catalog",
  jobs: "Jobs",
  shopFloor: "Shop floor",
  materials: "Materials & purchasing",
  purchasing: "Purchasing",
  invoices: "Invoices & cash",
  reports: "Reports",
  documents: "Documents",
  users: "Users",
  imports: "Import data",
  auditTrail: "Audit trail",
  settings: "Settings",
};
